<div class="flex flex-col justify-start items-stretch bg-gray-100 min-h-screen p-4" #container>
  <ng-container *ngIf="(showSignaturePane$ | async) === false">
    <ng-container *ngIf="connected; else notConnected">
      <div class="flex flex-row justify-between items-center bg-white rounded-lg p-4 shadow-sm mb-4">
        <div class="flex items-center">
          <span class="inline-block w-3 h-3 bg-green-500 rounded-full mr-2"></span>
          <p class="text-sm font-medium">Connected</p>
        </div>
        <p *ngIf="!showTerminalCodeInstructions" class="font-mono font-bold">
          {{ terminalCode }}
        </p>
      </div>
      <ng-container *ngIf="showTerminalCodeInstructions">
        <div
          class="flex flex-col justify-center items-center text-center space-y-8 py-12 bg-white rounded-lg shadow-sm">
          <p class="text-lg px-6">
            To send signature requests to this device, enter this code when prompted:
          </p>
          <p class="text-6xl tracking-widest font-mono font-bold text-blue-600">{{ terminalCode }}</p>
          <button mat-raised-button color="primary" (click)="showTerminalCodeInstructions = false" class="px-8">
            Hide
          </button>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="showSignaturePane$ | async">
    <div class="flex flex-row justify-between items-center py-4 bg-white rounded-lg shadow-sm mb-4 px-4">
      <p class="text-center font-medium">{{ infoDisplay$ | async }}</p>
      <button mat-icon-button (click)="cancelSignature()" aria-label="Cancel">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="bg-white rounded-lg shadow-sm p-4">
      <app-signature-capture [signableId]="signableId$ | async" [signableType]="signableType$ | async"
        (cancel)="cancelSignature()" (signatureSaved)="showSuccessAndClearAfterTimeout()"
        [signableStage]="signableStage$ | async"></app-signature-capture>
    </div>
  </ng-container>
  <ng-template #notConnected>
    <div class="flex flex-col items-center justify-center space-y-4 bg-white rounded-lg shadow-sm p-6 mt-8">
      <div class="flex items-center">
        <span class="inline-block w-3 h-3 bg-red-500 rounded-full mr-2"></span>
        <p class="font-medium">Not connected to notification service</p>
      </div>
      <p *ngIf="error" class="text-red-500 text-center">{{ error }}</p>
      <button mat-raised-button color="primary" *ngIf="allowRetries && !connected"
        (click)="connectToNotificationServer()" class="mt-2">
        Retry Connection
      </button>
    </div>
  </ng-template>
</div>